import React from 'react'
import Link from "helpers/link";
import { shopURL } from "utils/constants";

const Banner = ({ data }) => {
  return (
    <div className='w-full flex justify-center px-4'>
        <div style={{"backgroundImage": `url(${data.bgImage.src})`}} className='w-full flex lmd:flex-col-reverse max-w-[1400px] justify-between items-center pl-36 pr-12 lmd:p-0 bg-no-repeat lmd:bg-cover lmd:bg-center lmd:pb-12 lmd:px-5'>
            <div className='flex flex-col'>
                <div className='flex flex-col font-display text-5xl lmd:text-2xl mb-12 lmd:mb-4'>
                    <h2 className='mb-2 !text-yellow-400'> {data.title} </h2>
                    <h2 className='text-white'> {data.subtitle} </h2>
                </div>
                <Link
                    to={data.buttonUrl}
                    className="btn btn-gold mt-4 w-fit lmd:w-full !px-12 lmd:!px-0"
                > 
                    {data.buttonText} 
                </Link>
            </div>
            <div className='w-full max-w-[410px] xsm:w-10/12'>
                <img src={data.rightSideImage.src} alt={`${data.title} - ${data.subtitle}`} />
            </div>
        </div>
    </div>
  )
}

export default Banner